
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import { Link } from 'react-router-dom';

export default function AboutCTA() {
  const section = useScrollAnimation();

  return (
    <section className="py-28 px-8 bg-white">
      <div className="max-w-[1400px] mx-auto">
        <div
          ref={section.ref}
          className={`relative rounded-3xl overflow-hidden transition-all duration-1000 ${
            section.isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
          }`}
        >
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/7867d3237c48d9307024faac7a884fe7.jpg"
              alt="CTA Background"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-[#1A2332]/85"></div>
          </div>

          <div className="relative py-20 px-8 text-center">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
              Ready to start your<br />transformation journey?
            </h2>
            <p className="text-base text-gray-300 max-w-lg mx-auto mb-10 leading-relaxed">
              Let&apos;s explore how TechVision can help you unlock new possibilities and drive sustainable growth for your business.
            </p>
            <div className="flex items-center justify-center gap-4">
              <Link
                to="/services"
                className="px-8 py-4 bg-white text-[#1A2332] rounded-lg font-semibold text-sm hover:bg-gray-100 transition-all duration-300 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                Explore Our Services
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/careers"
                className="px-8 py-4 border border-white/30 text-white rounded-lg font-semibold text-sm hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Join Our Team
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
